import React, { Suspense } from "react";
import ProtectedRoute from "ProtectedRoute";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";

// Plan K Phase 5 — Enterprise Action Engine module routes. Promotes the
// agent + briefing surfaces (currently buried under AFMS) into a cross-
// module hub. Lane-gated by `lane.enterprise_action_engine` — sidenav hides
// the whole group when the org has no `enterprise_briefings` /
// `agent_runs` / `priority_support` entitlement.
//
// The legacy AFMS Morning Briefing sidenav entries stay where they are
// (src/afms/pages/Briefing/) — Enterprise is additive, not a relocation.
const EnterpriseOverview = React.lazy(() => import("enterprise/pages/Overview"));
const EnterpriseActionEngine = React.lazy(() => import("enterprise/pages/ActionEngine"));
const EnterpriseBriefings = React.lazy(() => import("enterprise/pages/Briefings"));

const enterpriseRoutes = [
  {
    type: "collapse",
    name: "Enterprise",
    key: "enterprise-action-engine",
    icon: <HubOutlinedIcon />,
    laneKey: "lane.enterprise_action_engine",
    collapse: [
      {
        name: "Overview",
        key: "enterprise-overview",
        route: "/enterprise",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <EnterpriseOverview />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        name: "Action Engine",
        key: "enterprise-action-engine-console",
        route: "/enterprise/action-engine",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <EnterpriseActionEngine />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        name: "Briefings",
        key: "enterprise-briefings",
        route: "/enterprise/briefings",
        component: (
          <ProtectedRoute>
            <Suspense fallback={null}>
              <EnterpriseBriefings />
            </Suspense>
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default enterpriseRoutes;
